import { render, staticRenderFns } from "./ftp-info.vue?vue&type=template&id=f0f8ab62&"
import script from "./ftp-info.vue?vue&type=script&lang=js&"
export * from "./ftp-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports